<template>
  <b-row>
    <b-col cols="12" lg="7">
      <b-list-group>
        <b-list-group-item>
          <div class="d-flex justify-content-between">
            <span>{{ 'barcode' | lang }}</span>
            <span>{{ ticket.barcode }}</span>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="d-flex justify-content-between">
            <span>{{ 'datetime_payout' | lang }}</span>
            <span>{{ ticket.datetime_payout }}</span>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="d-flex justify-content-between">
            <span>{{ 'amount' | lang }}</span>
            <span>{{ ticket.amount | currency }}</span>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="d-flex justify-content-between">
            <span>{{ 'paylines_count' | lang }}</span>
            <span>{{ ticket.scenarios[0].lines_count }}</span>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="d-flex justify-content-between">
            <span>{{ 'amount_payout' | lang }}</span>
            <span v-if="ticket.amount_payout">{{ ticket.amount_payout | currency }}</span>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-col>
    <b-col cols="12" lg="5">
      <rhombus v-if="type === 'Rhombus'" v-bind:ticket="ticket"></rhombus>
      <square v-if="type === 'Square'" v-bind:ticket="ticket"></square>
    </b-col>
  </b-row>
</template>

<script>
import Square from './History/Square.vue';
import Rhombus from './History/Rhombus.vue';

export default {
  components: {Square, Rhombus},
  props: ['ticket', 'iteration', 'gameName'],
  computed: {
    type() {
      switch (this.iteration) {
        case 'FantasyGemsA':
          return 'Rhombus';
        default:
          return 'Square';
      }
    },
    symbolsMapped() {
      let mappedSymbols = {};

      for (const [ key, symbol ] of Object.entries(Config.symbols)) {
        const fileName = Config.assets.spritesheets[`symbol_${symbol.name}_spritesheet`];
        const blocks =  fileName.split('_').map(num => parseInt(num));
        const frameHeight = blocks.pop();
        const frameWidth = blocks.pop();

        mappedSymbols[symbol.name] = {frameWidth, frameHeight, fileName};
      }

      return mappedSymbols;
    },
  },
  methods: {
    getSymbolStyle(symbol, requiredWidth) {
      const ratio = this.symbolsMapped[symbol]['frameWidth'] / requiredWidth;
      const height = this.symbolsMapped[symbol]['frameHeight']  / ratio;

      const bgWidth = Config.symbolsTextureData[symbol].width / ratio;
      let positionX = 0;

      if(Config.symbolNormalFrame) {
        positionX = -(requiredWidth * Config.symbolNormalFrame);
      }

      return `
                width: ${requiredWidth}px;
                height: ${height}px;
                background:url(/sl/v1/games/${this.gameName}/${this.symbolsMapped[symbol]['fileName']});
                background-size: ${bgWidth}px auto;
                background-position: ${positionX}px 0px;
            `;
    },
  },
}
</script>